module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point3_4-8465c5f55c8c6d71f376da5cdadb34f2.jpg";